<template>
  <div class="form__field">
    <div class="form__title" v-show="field.title">{{ field.title }}</div>
    <div class="form__spacer" v-show="field.title"></div>
    <label class="form__label" v-show="field.label" :for="identifier">
      {{ field.label }}
    </label>
    <div
      class="form__control form__control--compressed"
      v-for="option in field.options"
      :key="field.name + '-' + option.value"
      @click="check(field)"
    >
      <input
        type="radio"
        v-model="value"
        :id="identifier + '_' + option.value"
        :name="identifier"
        :value="option.value"
        :disabled="option.disabled"
      />
      <label class="form__radio" :for="identifier + '_' + option.value">
        <span class="form__radio__indicator"></span>
        {{ option.label }}
      </label>
    </div>
    <div
      class="form__control form__control--compressed"
      v-for="childField in childFields"
      :key="field.name + '-' + childField.name"
      @click="check(childField)"
    >
      <input
        type="radio"
        v-model="value"
        :id="identifier + '_' + childField.value"
        :name="identifier"
        :value="childField.value"
        :disabled="childField.disabled"
      />
      <div
        class="form__radio form__radio--nolabeled"
        :for="childField.identifier"
      >
        <span class="form__radio__indicator"></span>
        <component
          :field="childField"
          :is="'checkout-field-' + childField.type"
        >
        </component>
      </div>
    </div>
    <div class="form__message form__message--error" v-show="field.error">
      {{ field.error }}
    </div>
  </div>
</template>

<script>
import * as Components from ".";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-radio",
  computed: {
    childFields: function() {
      return this.field.fields.filter(field => !field.disabled);
    }
  },
  methods: {
    check: function(field) {
      this.current = field;
      this.$store.dispatch("updateField", {
        field: this.field,
        newProps: { value: field.value }
      });
    }
  },
  updated() {
    if (this.field.valid === false) {
      return;
    }

    this.$store.dispatch("updateField", {
      field: this.field,
      newProps: { value: this.current ? this.current.value : null }
    });
  }
};
</script>
